import { LayoutMetadata, LayoutMetadataBase } from "./layout-metadata.model";


export abstract class ExtendedLayoutMetadataBase extends LayoutMetadataBase {

    name!: string
    addLabel!: string
    description!: string
    fieldName!: string
    items: LayoutMetadata [] = []
    atLeastOne: boolean = false
    titleError!: string
    descriptionError!: string

}

export interface ExtendedLayoutMetadata extends ExtendedLayoutMetadataBase { }